import { Icon } from "@/core/components/icon/Icon"
import { List } from "@/core/components/Lists"
import React from "react"
import { useTranslation } from "next-i18next"
import { Label } from "@/core/components/Label"
import { Button } from "@/core/components/Button"

export const SupplierApps = () => {
  const { t } = useTranslation("upgrade")

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="w-full overflow-hidden">
        <img className="w-full object-left-bottom" src="/bg-sales.jpg" />
      </div>
      <div className="bg-container-high text-on-surface shadow-elevation-6 absolute flex w-[30rem] flex-col gap-8 rounded-xl p-10">
        <div className="flex flex-col gap-6">
          <h4 className="text-4xl font-medium">{t("title")}</h4>
          <span className="font-light">{t("unavailable")}</span>
        </div>
        <div className="flex flex-col gap-6">
          <List>
            <div className="flex flex-col gap-6">
              <div className="flex w-full items-center gap-4">
                <CustomCheckIcon />
                <Label size="lg" variant="semibold">
                  {t("features.leads.title")}
                </Label>
              </div>
              <div className="flex w-full items-center gap-4">
                <CustomCheckIcon />
                <Label size="lg" variant="semibold">
                  {t("features.proposals.title")}
                </Label>
              </div>
              <div className="flex w-full items-center gap-4">
                <CustomCheckIcon />
                <Label size="lg" variant="semibold">
                  {t("features.insights.title")}
                </Label>
              </div>
            </div>
          </List>
          <span className="font-light">{t("end_note")}</span>
        </div>
        <a
          className="flex flex-col"
          href="https://www.flextribe.io/pricing"
          rel="noreferrer"
          target="_blank"
        >
          <Button>
            <span>{t("ask_for_demo")}</span>
          </Button>
        </a>
      </div>
    </div>
  )
}

const CustomCheckIcon = () => {
  return (
    <div className="relative flex flex-col justify-start">
      <Icon
        icon={"check"}
        size="xl"
        // className="text-primary absolute bottom-0 left-0 scale-[166.66%]"
        className="!text-primary absolute bottom-0 left-0 pl-0.5"
      />
      <div className="bg-container-low h-7 w-7 rounded-full" />
    </div>
  )
}
